// components/Footer.jsx
import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
    return (
        <footer className="bg-gray-900 text-gray-300 py-12">
            <div className="max-w-7xl mx-auto px-6 lg:px-8">
                <div className="grid md:grid-cols-4 gap-8">
                    <div>
                        <h4 className="text-white font-bold text-lg mb-4">Arxis Accounting</h4>
                        <p className="text-sm">Precision accounting software for Nigerian businesses.</p>
                    </div>
                    <div>
                        <h5 className="font-semibold text-white mb-3">Product</h5>
                        <ul className="space-y-2 text-sm">
                            <li><a href="#" className="hover:text-white">Features</a></li>
                            <li><a href="#" className="hover:text-white">Pricing</a></li>
                            <li><Link to="/security" className="hover:text-white">Security</Link></li>
                        </ul>
                    </div>
                    <div>
                        <h5 className="font-semibold text-white mb-3">Company</h5>
                        <ul className="space-y-2 text-sm">
                            <li><Link to="/about-us" className="hover:text-white">About</Link></li>
                            <li><Link to="/contact-us" className="hover:text-white">Contact</Link></li>
                            <li><Link to="/privacy-policy" className="hover:text-white">Privacy Policy</Link></li>
                        </ul>
                    </div>
                    <div>
                        <h5 className="font-semibold text-white mb-3">Support</h5>
                        <ul className="space-y-2 text-sm">
                            <li><a href="#" className="hover:text-white">Help Center</a></li>
                            <li><a href="#" className="hover:text-white">Live Chat</a></li>
                            <li><a href="#" className="hover:text-white">Status</a></li>
                        </ul>
                    </div>
                </div>
                <div className="mt-10 pt-8 border-t border-gray-800 text-center text-sm">
                    © {new Date().getFullYear()} Arxis Accounting. All rights reserved.
                </div>
            </div>
        </footer>
    );
}